module.exports = {
    future: {
        removeDeprecatedGapUtilities: true,
        purgeLayersByDefault: true
    },
    purge: {
        content: [
            "*.php",
            "templates/**/*.php",
            "parts/**/*.php",
            "blocks/**/*.php",
            "src/helpers.php",
            "assets/scripts/**/*.js",
            "./../lr-theme-riks/*.php",
            "./../lr-theme-riks/**/*.php"
        ],
        options: {
            whitelist: [
                "ml-4",
                "py-2",
                "whitespace-no-wrap",
                "lg:hidden",
                "xl:hidden",
                "mb-auto",
                "mt-4",
                "my-6",
                "max-w-sm",
                "mt-0",
                "mb-0",
                "my-0",
                "md:pt-16",
                "pt-8",
                "text-tertiary-neutral",
                "h-12",
                "-mb-4",
                "-mb-6",
                "z-30"
            ]
        }
    },
    theme: {
        fontSize: {
            xs: ["11px", "1.5"],
            sm: ["14px", "1.5"],
            base: ["15.5px", "1.65"],
            md: ["1.2rem", "1.5"],
            lg: ["1.25rem", "1.3"],
            xl: ["1.563rem", "1.3"],
            "2xl": ["1.953rem", "1.2"],
            "3xl": ["2.441rem", "1.2"],
            "4xl": ["3.052rem", "1.1"],
            "5xl": ["3.815rem", "1.1"],
            "6xl": ["6.065rem", "1.1"]
        },
        fontFamily: {
            main: ["Raleway", "system-ui", "sans-serif"]
        },
        extend: {
            colors: {
                primary: {
                    default: "#005192",
                    light: "#0068bb"
                },
                secondary: {
                    default: "#84B818",
                    light: "#99CC2F"
                },
                tertiary: {
                    default: "#D8D8D8",
                    dark: "#616263"
                },
                neutral: {
                    light: "#ececec",
                    default: "#ffffff",
                    shade: "#f4f4f3"
                },
                dark: "#222",
                state: {
                    success: "#3c763d",
                    "success-light": "#ddeedd",
                    "success-dark": "#4d984e",
                    warning: "#ffdd57;",
                    "warning-light": "#fff7d6",
                    "warning-dark": "#705a00",
                    danger: "#a94442",
                    "danger-light": "#f2dfde",
                    "danger-dark": "#c0605e",
                    info: "#31708f",
                    "info-light": "#e3eff5",
                    "info-dark": "#3e8eb5"
                }
            },
            screens: {
                "2xl": "1640px",
                max: "2565px"
            },
            zIndex: {
                "-10": "-10"
            },
            gridTemplateColumns: {
                primary: "repeat(3, minmax(250px, auto))"
            },
            width: {
                max: "max-content"
            },
            maxWidth: {
                content: "65ch"
            },
            inset: {
                full: "100%"
            },
            minHeight: {
                card: "529px"
            },
            borderWidth: {
                "1": "1px"
            }
        },
        container: {
            center: true
        }
    },
    variants: {
        backgroundColor: ["hover", "focus", "even", "odd"]
    },
    plugins: []
};
